export const CRM_SIGNUP = 'CrmSignup';
export const SALES_SIGNUP = 'SalesSignup';
export const SERVICE_SIGNUP = 'ServiceSignup';
export const MARKETING_SIGNUP = 'MarketingSignup';
export const TRIAL_SIGNUP = 'TrialSignup';
export const CMS_FREE_SIGNUP = 'CmsFreeSignup';